import React from "react";
import { useConfigs } from "../configuration/useConfigs";
import {
  FormControl,
  InputLabel,
  Select,
  ListSubheader,
  MenuItem,
  Checkbox,
} from "@mui/material";

const RegionCountriesRefinement = ({ regionList = [], country = [], setCountry }) => {
  const { config } = useConfigs();

  // Group countries by region
  const groupedRegions = regionList.reduce((acc, countryItem) => {
    const { regionName } = countryItem;
    if (!regionName) return acc;
    if (!acc[regionName]) acc[regionName] = [];
    acc[regionName].push(countryItem);
    return acc;
  }, {});

  // Convert grouped object to array format
  const regionsArray = Object.entries(groupedRegions).map(([regionName, countries]) => ({
    regionName,
    countries,
  }));

  const handleRegionSelection = (region) => {
    const regionCountries = region.countries.map((c) => c.countryLongName);
    const isRegionSelected = regionCountries.every((c) => country.includes(c));

    setCountry(
      isRegionSelected
        ? country.filter((c) => !regionCountries.includes(c)) // Deselect all in region
        : [...country, ...regionCountries] // Select all in region
    );
  };

  const handleCountrySelection = (countryName) => {
    setCountry(
      country.includes(countryName)
        ? country.filter((c) => c !== countryName) // Deselect
        : [...country, countryName] // Select
    );
  };

  return (
    <FormControl
      sx={{ m: 1, width: "250px", backgroundColor: "white" }}
      variant="outlined"
    >
      <InputLabel id="region-country-label" size="small">
        Destination Region/Country
      </InputLabel>
      <Select
        labelId="region-country-label"
        id="region-country"
        multiple
        value={country}
        label="Destination Region/Country"
        onChange={() => {}}
        size="small"
        fullWidth
        className="country-select"
        renderValue={(selected) =>
          selected.length > 1 ? `${selected.length} items` : selected[0]
        }
      >
        {/* Grouped Regions with Countries */}
        {regionsArray.map((region) => (
          <React.Fragment key={region.regionName}>
            {/* Region Header with Select/Deselect */}
            <ListSubheader
              sx={{
                fontWeight: "bold",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => handleRegionSelection(region)}
            >
              <Checkbox
                sx={{ p: "5px" }}
                checked={region.countries.every((c) => country.includes(c.countryLongName))}
                indeterminate={
                  region.countries.some((c) => country.includes(c.countryLongName)) &&
                  !region.countries.every((c) => country.includes(c.countryLongName))
                }
              />
              {region.regionName}
            </ListSubheader>

            {/* Countries under Region */}
            {region.countries.map((countryItem) => (
              <MenuItem
                key={countryItem.countryLongName}
                value={countryItem.countryLongName}
                sx={{ pl: "24px" }} // Indent country items
                onClick={() => handleCountrySelection(countryItem.countryLongName)}
              >
                <Checkbox
                  sx={{ p: "5px" }}
                  checked={country.includes(countryItem.countryLongName)}
                />
                {countryItem.countryLongName}
              </MenuItem>
            ))}
          </React.Fragment>
        ))}
      </Select>
    </FormControl>
  );
};

export default RegionCountriesRefinement;
